// Shared className recipes + label maps for a cohesive PDG look.
export const goldBtn =
  "inline-flex items-center justify-center gap-2 rounded-xl border border-[hsl(var(--pdg-gold)/0.55)] " +
  "text-[hsl(var(--pdg-gold))] bg-transparent hover:bg-[hsl(var(--pdg-gold)/0.12)] " +
  "hover:border-[hsl(var(--pdg-gold)/0.8)] transition-colors duration-200 px-5 h-11 text-sm font-medium " +
  "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[hsl(var(--pdg-gold)/0.55)] disabled:opacity-50";

export const goldBtnSm =
  "inline-flex items-center justify-center gap-2 rounded-lg border border-[hsl(var(--pdg-gold)/0.5)] " +
  "text-[hsl(var(--pdg-gold))] bg-transparent hover:bg-[hsl(var(--pdg-gold)/0.12)] " +
  "transition-colors duration-200 px-3 h-9 text-xs font-medium disabled:opacity-50";

export const glassBtn =
  "inline-flex items-center justify-center gap-2 rounded-xl bg-[hsl(var(--pdg-glass)/0.5)] backdrop-blur-md " +
  "border border-border text-foreground/90 hover:bg-[hsl(var(--pdg-glass)/0.7)] " +
  "hover:border-[hsl(var(--pdg-gold)/0.3)] transition-colors duration-200 px-5 h-11 text-sm";

export const inputCls =
  "w-full bg-[hsl(var(--pdg-charcoal))] border border-border rounded-xl px-3 h-11 text-sm text-foreground " +
  "placeholder:text-[hsl(var(--muted-foreground))] focus:outline-none focus:ring-2 " +
  "focus:ring-[hsl(var(--pdg-gold)/0.45)] transition-shadow";

export const textareaCls =
  "w-full bg-[hsl(var(--pdg-charcoal))] border border-border rounded-xl px-3 py-3 text-sm text-foreground " +
  "placeholder:text-[hsl(var(--muted-foreground))] focus:outline-none focus:ring-2 " +
  "focus:ring-[hsl(var(--pdg-gold)/0.45)] transition-shadow";

export const labelCls = "block text-xs uppercase tracking-[0.16em] text-muted-foreground mb-2";

export const container = "max-w-6xl xl:max-w-7xl mx-auto px-4 sm:px-6 lg:px-8";

export const SECTORS = {
  real_estate: "European Real Estate",
  private_credit: "Private Credit",
  real_assets: "Real Assets",
  late_stage_equity: "Late-Stage Equity",
};

export const SECTOR_SHORT = {
  real_estate: "Real Estate",
  private_credit: "Private Credit",
  real_assets: "Real Assets",
  late_stage_equity: "Late-Stage Equity",
};

export const TIERS = {
  observer: "Observer",
  principal: "Principal",
  mandate_partner: "Mandate Partner",
};

export const AUM = {
  under_50m: "Under £50m",
  "50m_250m": "£50m – £250m",
  "250m_1bn": "£250m – £1bn",
  over_1bn: "Over £1bn",
};

export const ORG_TYPES = {
  family_office: "Family Office",
  investment_vehicle: "Investment Vehicle",
  operator: "Operator",
  other: "Other",
};
